import { EnumListItem } from '../../../../ui/gzEnumList/types';

export interface ExtendedTagEnumListItem extends EnumListItem {
  additionalData?: AdditionalData;
}

export interface AdditionalData {
  type: number;
}

export enum ExcludedTagTypes {
  NO_TAGS_SELECTED = -100,
}
